// * Angular
import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  LOCALE_ID,
} from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideRouter, withViewTransitions } from '@angular/router';

// * Routes
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { MatDialogModule } from '@angular/material/dialog';
import { Interceptor } from './core/interceptors/interceptor.service';
import { providePrimeNG } from 'primeng/config';
import {
  provideServiceWorker,
  ServiceWorkerModule,
} from '@angular/service-worker';
import { primeNGEn, primeNGEs } from './primeng-i18n';

const lang = localStorage.getItem('lang') || 'es';
const translation = lang === 'en' ? primeNGEn : primeNGEs;

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true,
    },

    // ✅ Agregar LOCALE_ID
    {
      provide: LOCALE_ID,
      useValue: 'es-MX',
    },
    

    // Configuración de rutas
    provideRouter(routes, withViewTransitions()),

    // HttpClient con interceptores
    provideHttpClient(withInterceptorsFromDi()),

    // Animaciones asíncronas
    provideAnimationsAsync(),

    // Charts con configuraciones predeterminadas
    provideCharts(withDefaultRegisterables()),

    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),

    providePrimeNG({
      translation
    }),
    
  ],
};
